var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"loading",attrs:{"show":_vm.show}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showView),expression:"showView"}],staticClass:"s-overlay"},[_c('van-loading',{attrs:{"color":_vm.color,"vertical":_vm.vertical,"text-size":"12px"}},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }